import { OpenInNewRounded as LinkIcon } from "@mui/icons-material";
import { Box, Tooltip, useTheme } from "@mui/material";
import IconButton from "components/common/IconButton";
import { Link } from "react-router-dom";

const SubmissionLink = ({ insured, submissionId, path, variant }) => {
  const theme = useTheme();
  variant = (variant ?? "").trim().toLowerCase();
  const url = `/submissions/${submissionId}${path ?? ""}`;

  return (
    <Link to={url} target={"_blank"} style={{ color: theme.brand.accent[800] }}>
      {variant === "icon" ? (
        <Tooltip title={"Open in new tab"}>
          <LinkIcon color={"primary"} />
        </Tooltip>
      ) : variant === "smallicon" ? (
        <Box display={"flex"} alignItems={"center"} justifyContent={"center"}>
          <LinkIcon fontSize={"small"} />
        </Box>
      ) : variant === "buttonicon" ? (
        <IconButton variant={"bright"} icon={LinkIcon} />
      ) : (
        <span>{insured}</span>
      )}
    </Link>
  );
};

export default SubmissionLink;
